import "core-js/modules/es.regexp.flags.js";
import "core-js/modules/es.array.push.js";
// import kefu1 from "@/assets/images/kefu1.gif";
// import kefuLeft from "@/assets/images/kefu-left.gif";
// import arrowLeft from "@/assets/images/arrow-left.png";
// import kefuRight from "@/assets/images/kefu-right.gif";
// import arrowright from "@/assets/images/arrow-right.png";
export default {
  name: "DragBall",
  props: {
    kefu1: String,
    kefuLeft: String,
    arrowLeft: String,
    kefuRight: String,
    arrowright: String,
    appType: String
  },
  data() {
    return {
      kfImg: "",
      // 客服图标  arrowright    arrowright  kefu1
      kfImgFlag: false,
      // 客服图标宽度判断标识
      count: 0,
      flags: false,
      timerId: null,
      // 定时器
      position: {
        kefuWidth: 65,
        x: window.screen.width - 65,
        y: window.screen.height - window.screen.height * 0.3
      },
      dx: "",
      dy: "",
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
      defaultIcon: true
    };
  },
  created() {
    this.clientWidth = document.documentElement.clientWidth;
    this.clientHeight = document.documentElement.clientHeight;
  },
  mounted() {
    this.kfImg = this.kefuRight;
    window.addEventListener("resize", this.clientWidthHandle);
    this.defaultIconHandle();
  },
  methods: {
    // 首次进入客服图标动画状态
    defaultIconHandle() {
      this.timerId = setTimeout(() => {
        this.defaultIcon = false;
        this.count = 0;
        this.position.kefuWidth = 25;
        this.position.x = this.screenWidth - 25;
        this.kfImg = this.arrowright;
        this.flags = false;
      }, 4000);
    },
    clientWidthHandle() {
      this.screenWidth = window.screen.width;
      this.screenHeight = window.screen.height;
    },
    goCustomerService: function (event) {
      let {
        topStatusHeight,
        navHeight,
        lang
      } = this.$route.query;
      if (this.defaultIcon) {
        if (this.appType === "cloudSee") {
          window.location.href = "https://chatbot.aliyuncs.com/intl/index.htm?locale=zh-CN&from=OSLqV3VKlV";
        } else {
          this.$router.push({
            path: "/dist/customerServiceChat",
            query: {
              topStatusHeight,
              navHeight,
              lang,
              sourceType: 1
            }
          });
        }
        // window.location.href =
        //   "http://test-auth.hapseemate.cn/cloudstorge/customerService?lang=zh&did=";
        // window.location.href =
        //   "https://wechat.hapseemate.cn/cloudstorge/customerService?lang=zh&did=";
      } else {
        let _this = this;
        this.count++;
        if (this.count === 2) {
          if (this.appType === "cloudSee") {
            window.location.href = "https://chatbot.aliyuncs.com/intl/index.htm?locale=zh-CN&from=OSLqV3VKlV";
          } else {
            this.$router.push("/dist/customerServiceChat");
          }
          // window.location.href =
          //   "https://chatbot.aliyuncs.com/intl/index.htm?from=Szrd8rOtLw&locale=zh-CN";
          // window.location.href =
          //   "http://test-auth.hapseemate.cn/cloudstorge/customerService?lang=zh&did=";
          // window.location.href =
          //   "https://wechat.hapseemate.cn/cloudstorge/customerService?lang=zh&did=";
          this.count = 0;
          setTimeout(() => {
            _this.changeIcon(event);
          }, 1000);
        }
      }
    },
    // 跳转后图标自动贴边
    changeIcon: function (event) {
      if (event.target.offsetParent.offsetLeft === 0) {
        this.count = 0;
        this.defaultIcon = false;
        this.kfImgFlag = true;
        this.position.kefuWidth = 25;
        this.kfImg = this.arrowLeft;
        this.position.x = 0;
      }
      if (event.target.offsetParent.offsetLeft < this.screenWidth / 2) {
        this.kfImgFlag = true;
        this.position.kefuWidth = 25;
        this.kfImg = this.arrowLeft;
        this.position.x = 0;
        this.flags = false;
        this.count = 0;
      } else {
        this.kfImgFlag = true;
        this.position.kefuWidth = 25;
        this.position.x = this.screenWidth - 25;
        this.kfImg = this.arrowright;
        this.flags = false;
        this.count = 0;
      }
    },
    // 实现移动端拖拽
    down(event) {
      console.log(`down->`);
      clearTimeout(this.timerId);
      this.position.kefuWidth = 65;
      this.flags = true;
      // this.kfImg = kefu1;
      // this.kfImgFlag = false;
      var touch;
      if (event.touches) {
        touch = event.touches[0];
      } else {
        touch = event;
      }
      this.dx = touch.clientX - event.target.offsetParent.offsetLeft;
      this.dy = touch.clientY - event.target.offsetParent.offsetTop;
    },
    move(event) {
      console.log(`move->`);
      this.position.kefuWidth = 65;
      this.kfImg = this.kefu1;
      this.kfImgFlag = false;
      if (this.flags) {
        var touch;
        if (event.touches) {
          touch = event.touches[0];
        } else {
          touch = event;
        }
        // 定位滑块的位置
        this.position.x = touch.clientX - this.dx;
        this.position.y = touch.clientY - this.dy;
        // 限制滑块超出页面
        // console.log('屏幕大小', screenWidth, screenHeight )
        if (this.position.x < 0) {
          this.position.x = 0;
        } else if (this.position.x > this.screenWidth - touch.target.clientWidth) {
          this.position.x = this.screenWidth - touch.target.clientWidth;
        }
        if (this.position.y < 0) {
          this.position.y = 0;
        } else if (this.position.y > this.screenHeight - touch.target.clientHeight) {
          this.position.y = this.screenHeight - touch.target.clientHeight;
        }
        //阻止页面的滑动默认事件
        document.addEventListener("touchmove", function (event) {
          event.stopPropagation();
          event.preventDefault();
        }, false);
      }
      event.stopPropagation();
    },
    //鼠标释放时候的函数
    end(event) {
      console.log(`end->`);
      if (event.target.offsetParent.offsetLeft === 0) {
        this.kfImgFlag = true;
        this.kfImg = this.kefuLeft;
        this.position.x = 0;
        this.timerId = setTimeout(() => {
          this.position.kefuWidth = 25;
          this.kfImg = this.arrowLeft;
          this.position.x = 0;
          this.count = 0;
        }, 4000);
        return;
      }
      // debugger;
      if (event.target.offsetParent.offsetLeft < this.screenWidth / 2) {
        this.kfImgFlag = true;
        this.kfImg = this.kefuLeft;
        this.position.x = 0;
        this.timerId = setTimeout(() => {
          this.position.kefuWidth = 25;
          this.kfImg = this.arrowLeft;
          this.position.x = 0;
          this.flags = false;
          this.count = 0;
        }, 4000);
      } else {
        this.kfImgFlag = true;
        this.kfImg = this.kefuRight;
        this.position.x = this.screenWidth - 65;
        this.timerId = setTimeout(() => {
          this.position.kefuWidth = 25;
          this.position.x = this.screenWidth - 25;
          this.kfImg = this.arrowright;
          this.flags = false;
          this.count = 0;
        }, 4000);
      }
    }
  }
};